package com.rajen.angrejidictionary.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class WordResponse(
    val success: Boolean,
    val data: ItemDto? = null,
    val error: AdminErrorDto? = null
)

@Serializable
data class WordSearchResponse(
    val success: Boolean,
    val data: List<ItemDto>? = null,
    val error: AdminErrorDto? = null
)

@Serializable
data class ItemDto(
    val id: String,
    val word: WordInfoDto,
    @SerialName("word_forms_inflections") val wordForms: List<WordFormDto> = emptyList(),
    @SerialName("similar_words") val similarWords: List<RelatedWordDto> = emptyList(),
    @SerialName("opposite_words") val oppositeWords: List<RelatedWordDto> = emptyList(),
    val usage: UsageDto? = null,
    @SerialName("phrasal_usage") val phrasalUsage: PhrasalUsageDto? = null,
    @SerialName("tense_explanation_gujarati") val tenseExplanation: TenseExplanationDto? = null,
    // Admin-only flag. Nullable so "not returned" can be told apart from false.
    @SerialName("is_premium") val isPremium: Boolean? = null,
    // Only returned by GET /items/word/{word}.
    @SerialName("view_count") val viewCount: Long? = null
)

@Serializable
data class WordInfoDto(
    @SerialName("english_word") val englishWord: String,
    @SerialName("category") val category: List<String> = emptyList(),
    @SerialName("part_of_speech") val partOfSpeech: String,
    @SerialName("pronunciation_gujarati") val pronunciationGujarati: String,
    @SerialName("meaning_gujarati") val meaningGujarati: List<String>
)

@Serializable
data class WordFormDto(
    @SerialName("english_word_form") val wordForm: String,
    @SerialName("part_of_speech") val partOfSpeech: String,
    @SerialName("pronunciation_gujarati") val pronunciationGujarati: String,
    @SerialName("meaning_gujarati") val meanings: List<String>,
    @SerialName("example_sentence") val example: ExampleSentenceDto? = null
)

@Serializable
data class ExampleSentenceDto(
    val sentence: String,
    @SerialName("sentence_pronunciation_gujarati") val pronunciationGujarati: String,
    @SerialName("sentence_meaning_gujarati") val meaningGujarati: String
)

@Serializable
data class RelatedWordDto(
    @SerialName("english_word") val word: String,
    @SerialName("part_of_speech") val partOfSpeech: String,
    @SerialName("pronunciation_gujarati") val pronunciationGujarati: String,
    @SerialName("meaning_gujarati") val meanings: List<String>
)

@Serializable
data class UsageDto(
    @SerialName("when_gujarati") val whenGujarati: String,
    @SerialName("where_gujarati") val whereGujarati: String,
    @SerialName("why_gujarati") val whyGujarati: String
)

@Serializable
data class PhrasalUsageDto(
    @SerialName("has_phrasal_form") val hasPhrasalForm: Boolean = false,
    val phrasals: List<PhrasalDto> = emptyList(),
    @SerialName("note_gujarati") val noteGujarati: String? = null
)

@Serializable
data class PhrasalDto(
    @SerialName("phrasal_form") val form: String,
    @SerialName("pronunciation_gujarati") val pronunciationGujarati: String,
    @SerialName("meaning_gujarati") val meanings: List<String>,
    @SerialName("example_sentences") val examples: List<ExampleSentenceDto> = emptyList()
)

@Serializable
data class TenseExplanationDto(
    @SerialName("tense_available") val available: Boolean = false,
    val tenses: List<TenseDto> = emptyList(),
    @SerialName("tense_explanation_rule") val rule: String = "",
    @SerialName("tense_note") val note: String = ""
)

@Serializable
data class TenseDto(
    @SerialName("tense_type") val type: String,
    @SerialName("tense_word") val word: String
)